import React, { useState, useEffect } from "react";
import "./BojagicardPage.css";

const BojagicardPage: React.FC = () => {
  const [kakaoLoaded, setKakaoLoaded] = useState(false);
  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  // 1. SDK 로드
  useEffect(() => {
    if (window.Kakao) {
      setKakaoLoaded(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.5/kakao.min.js";
    script.async = true;
    script.onload = () => setKakaoLoaded(true);
    document.body.appendChild(script);
  }, []);

  // iframe 로딩 완료 후 a 태그 target을 _parent로 변경
  const handleIframeLoad = () => {
    try {
      const iframe = iframeRef.current;
      if (iframe && iframe.contentDocument) {
        const links = iframe.contentDocument.querySelectorAll('a');
        links.forEach(link => {
          if (link.href && !link.href.startsWith('javascript:') && !link.href.startsWith('#')) {
            link.target = '_parent';
          }
        });
      }
    } catch (error) {
      console.log('iframe 접근이 제한되어 있습니다:', error);
    }
  };

  // 카카오톡 공유 직접 호출
  const handleKakaoShare = (e: React.MouseEvent) => {
    e.preventDefault();
    if (kakaoLoaded && window.Kakao && window.Kakao.Share) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init("ce21a9a0584e402f42f6e9bc767aa4b9");
      }
      window.Kakao.Share.sendCustom({
        templateId: 121583,
        templateArgs: { REGI_WEB_DOMAIN: "https://wedding.j1n.uk" },
      });
    } else {
      alert(
        "카카오톡 공유 기능을 불러오는 중입니다. 잠시 후 다시 시도해 주세요."
      );
    }
  };

  return (
    <div className="bojagicard-page">
      {/* Bojagicard 사이트 Embed */}
      <iframe
        ref={iframeRef}
        src="https://bojagicard.com/i/home.php?uid=znuke"
        style={{
          width: "100%",
          height: "calc(100vh - 20px)",
          border: "none",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1
        }}
        title="Bojagicard Wedding Invitation"
        allowFullScreen
        onLoad={handleIframeLoad}
      />


      {/* iOS 전용 플로팅 버튼 */}
      <a
        href="https://www.icloud.com/invites/07eQgaWYG0QzEiZldT9ch_vxg"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          right: 12,
          bottom: 32,
          zIndex: 10000,
          width: 54,
          height: 54,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          background: "none",
          border: "none",
          boxShadow: "none",
        }}
      >
        <img
          src="/assets/apple-invitatino.svg"
          alt="iOS 캘린더 초대"
          style={{ width: 54, height: 54, display: "block", opacity: 0.7 }}
        />
      </a>
    </div>
  );
};

export default BojagicardPage;
